import React from 'react';
import {Col, Row} from 'reactstrap';
import Contacts from "./Contacts";


const Intro = ({title, subtitle, showQR, qrcode, styles, data, social, printSocialAnchors, socialLinkSize, isFullPage}) => {
	// //console.log(social);

	return isFullPage ? (
		<div style={styles.section.intro || styles.section}>
			<Row>
				<Col md={7}>
					<div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-between">
						<div>
							<h1 style={styles.title}>{title}</h1>
							<h4 style={styles.designation}>{subtitle}</h4>
						</div>
					</div>
				</Col>
				<Col md={5}>
					<Contacts 
						data={data} 
						styles={styles} 
						social={social} 
						printSocialAnchors={printSocialAnchors}
						socialLinkSize={socialLinkSize}
					/>
				</Col>
			</Row>
		</div>
	) : (
		<div style={styles.section.intro || styles.section}>
			<div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-between">
				<div>
					<h1 style={styles.title}>{title}</h1>
					<h4 style={styles.designation}>{subtitle}</h4>
				</div>
			</div>
			<Contacts 
				data={data} 
				styles={styles} 
				social={social} 
				printSocialAnchors={printSocialAnchors}
				socialLinkSize={socialLinkSize}
			/>
		</div>
	);
};

export default Intro;